import React from 'react';
import TooltipParagraph from '../Catalog/tooltipParagraph';
import { formatNumber } from 'utils/helper';
import { Button } from 'antd';
import { useSelector } from 'react-redux';
import { selectTranslations } from '../App/slice/selectors';
import ReadMore from './ReadMore';
import styled from 'styled-components';
import Images from 'app/assets/img';
import useWindowSize from 'app/hooks/useWindowSize';

const ItemCombo = (props: any) => {
  const { item, onClick } = props;
  const translations = useSelector(selectTranslations);
  const { device } = useWindowSize();
  const isMobile = device === 'mobile';
  return (
    <ItemComboWrapper $isMobile={isMobile} className="my-3">
      <div className="row gap-3">
        <div className="col view-item-left-list">
          <div className="row pt-3 pb-3">
            <div className="col-auto">
              <img
                src={item?.imageUrl || Images.ImgBanner}
                alt=""
                className="combo-img"
                onError={e => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = Images.ImgBanner;
                }}
              />
            </div>
            <div className="col">
              <TooltipParagraph
                className="fw-bold mb-1"
                style={{
                  maxWidth: '100%',
                }}
                ellipsis={{ rows: 2 }}
              >
                {item.name || item.combo_name || item.otaSiteName || ''}
              </TooltipParagraph>
              <ReadMore lines={2} html={item.combo_description} />
            </div>
          </div>
        </div>
        <div
          className={`${
            isMobile ? 'col-12' : 'col-auto'
          } text-end d-flex flex-column pt-3 pb-3`}
        >
          <div
            style={{
              height: '100%',
              marginRight: isMobile ? 0 : 14,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div className="fw-bold text-black text-price">
              {`${formatNumber(item.paxPrice, '.')}đ`}
            </div>
            <Button
              className="btn-change-flight"
              style={{
                marginTop: 'auto',
                maxWidth: 'fit-content',
                alignSelf: 'flex-end',
                marginRight: 0,
              }}
              onClick={onClick}
            >
              {translations?.['b2b.txt.select']}
            </Button>
          </div>
        </div>
      </div>
    </ItemComboWrapper>
  );
};
export default ItemCombo;
const ItemComboWrapper = styled.div<{ $isMobile?: boolean }>`
  margin-left: ${({ $isMobile }) => ($isMobile ? 0 : '14px')};
  border-radius: 10px;
  background: #f2f2f2;
  .text-price {
    font-size: ${({ $isMobile }) => ($isMobile ? '18px' : '22px')};
    margin-bottom: ${({ $isMobile }) => ($isMobile ? '10px' : '0px')};
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .btn-change-flight {
    border: 1px solid #fab317;
    background: #f17922;
    background-image: linear-gradient(to right, #f06f24, #f8b117);
    color: #ffffff;
    border-radius: 8px;
    margin-right: ${({ $isMobile }) => ($isMobile ? 0 : '10px')};
    height: 35px;
  }
  .combo-img {
    width: ${({ $isMobile }) => ($isMobile ? '72px' : '96px')};
    height: ${({ $isMobile }) => ($isMobile ? '72px' : '96px')};
    object-fit: cover;
    border-radius: 8px;
  }
  .view-item-left-list {
    background: #fff;
    border-radius: 10px;
    border: 2px solid #f2f2f2;
  }
  @media (max-width: 768px) {
    .row.gap-3 {
      gap: 8px !important;
    }
    .text-end {
      text-align: left !important;
    }
    .btn-change-flight {
      width: 100%;
      max-width: none !important;
    }
  }
`;
